import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      verifyToken();
    } else {
      setLoading(false);
    }
  }, [token]);

  const verifyToken = async () => {
    try {
      const response = await axios.get(`${API}/admin/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data.username);
    } catch (error) {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    try {
      console.log('AuthContext: Attempting login to:', `${API}/admin/auth/login`);
      const response = await axios.post(`${API}/admin/auth/login`, {
        username,
        password
      });
      console.log('AuthContext: Login response received', response.data);
      const { access_token, username: user } = response.data;
      localStorage.setItem('admin_token', access_token);
      setToken(access_token);
      setUser(user);
      console.log('AuthContext: Login successful, user:', user);
      return response.data;
    } catch (error) {
      console.error('AuthContext: Login error:', error.response?.data || error.message);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setToken(null);
    setUser(null);
  };

  const getAuthHeaders = () => ({
    Authorization: `Bearer ${token}`
  });

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, getAuthHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};
